/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedJobsDto } from '../../models/paginated-jobs-dto';

export interface SuperadminControllerListJobs$Params {
  status?: 'pending' | 'claimed' | 'awaiting_input' | 'running' | 'completed' | 'failed' | 'expired' | 'cancelled';
  page?: number;
  pageSize?: number;
}

export function superadminControllerListJobs(http: HttpClient, rootUrl: string, params?: SuperadminControllerListJobs$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedJobsDto>> {
  const rb = new RequestBuilder(rootUrl, superadminControllerListJobs.PATH, 'get');
  if (params) {
    rb.query('status', params.status, {});
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedJobsDto>;
    })
  );
}

superadminControllerListJobs.PATH = '/superadmin/jobs';
